// extracted by mini-css-extract-plugin
export var filterIncDec = "_9z-0";
export var leftBorder = "_9z-1";
export var rightBorder = "_9z-2";
export var stringInput = "_9z-3";